import React, { useContext } from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import useDevice from "../../customHooks/useDevice";
import FeedItem from "./FeedItem";

function Instagram() {
  const { title, photosCount = 3 } = useContext(ComponentContext);

  const { configStore } = useStores();
  const { config } = configStore;

  const instagramPosts = config?.instagramPosts;

  const { isMobile } = useDevice();

  if (isEmpty(instagramPosts)) {
    return null;
  }

  const styledFeedWrapperClassName = classNames(
    "d-flex align-items-center col-12 justify-content-center",
    `col-lg-${Math.round(12 / photosCount)}`
  );

  const instagramFeedClassNames = classNames("row", {
    "gy-3 gx-3": isMobile,
    "justify-content-center": !isMobile,
  });

  return (
    <>
      <h2 className="text-center mb-5">{title}</h2>
      <div className={instagramFeedClassNames}>
        {instagramPosts.slice(0, photosCount).map((feedItem) => {
          return (
            <div key={feedItem.id} className={styledFeedWrapperClassName}>
              <FeedItem key={feedItem.id} feedItem={feedItem} />
            </div>
          );
        })}
      </div>
    </>
  );
}

export default observer(Instagram);
